import { IOrganization } from '../interfaces';

export const defaultOrganizationSettings: IOrganization = {
  name: '',
  logo: '',
  styles: {
    mainColor: '#FFDB00',
    contrastTextColor: '#011627',
  },
};
